import { Button, Tooltip } from 'antd'
import { SizeType } from 'antd/es/config-provider/SizeContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-solid-svg-icons'
import { CsvColumn, CsvDateRange, exportTableToCsv } from './reportCsvExport'

type Props<T> = {
  reportName: string
  dateRange: CsvDateRange
  columns: CsvColumn<T>[]
  rows: T[]
  size?: SizeType
  // Says what the file holds when it is more than what is on screen, e.g. every tab.
  tooltip?: string
}

const ExportCsvButton = <T,>({ reportName, dateRange, columns, rows, size, tooltip }: Props<T>) => (
  <Tooltip title={tooltip}>
    <Button
      size={size}
      icon={<FontAwesomeIcon icon={faDownload} />}
      disabled={rows.length === 0}
      onClick={() => exportTableToCsv(reportName, dateRange, columns, rows)}
    >
      Export CSV
    </Button>
  </Tooltip>
)

export default ExportCsvButton
